angular.module('eStories.purchase.choose', [
    'eStories.billing.model'
]).controller('ChoosePlanCtrl', [
    'ModalsModel',
    'ValidationModel',
    '$uibModalInstance',
    '$controller',
    '$scope',
    'AccountModel',
    'BillingModel',
    '$rootScope',
    function (ModalsModel,
              ValidationModel,
              $uibModalInstance,
              $controller,
              $scope,
              AccountModel,
              BillingModel,
              $rootScope) {
        var choosePlanCtrl = this;

        choosePlanCtrl.getPlanTabClass = function (family) {
            return choosePlanCtrl.displayedPlanFamily == family ? 'active' : '';
        };

        choosePlanCtrl.switchTab = function (family) {
            choosePlanCtrl.chosenPlan = null;
            choosePlanCtrl.displayedPlanFamily = family;
            BillingModel.getAllPlans(function (planMap) {
                choosePlanCtrl.planList = planMap[family];
                safeApply($scope);
            });
        };

        choosePlanCtrl.getPlanDiscount = function (plan) {
            if (plan.family == "ANNUAL") {
                switch (plan.name) {
                    case 'Basic':
                        return 17;
                        break;
                    case 'Plus':
                        return 19;
                        break;
                    case 'Premium':
                        return 20;
                        break;
                }
            }
            return null;
        };

        choosePlanCtrl.closeChoosePlanModal = function () {
            $uibModalInstance.close();
        };

        choosePlanCtrl.submitPlanChoice = function () {
            AccountModel.setChosenPlan(choosePlanCtrl.chosenPlan);
            safeApply($rootScope);
            $uibModalInstance.close();

            if (AccountModel.pendingPostChoosePlanAction == "SHOW_PAYMENT_DETAILS_FORM") {
                AccountModel.showUpdatePaymentDetailsModal();
            }
            AccountModel.setPendingPostChoosePlanAction(null);
        };
        choosePlanCtrl.switchTab("MONTHLY");
    }
]);
